import { useContext } from 'react';
import Search from '../../../Search/Search';
import { TableContext } from '../../Table.context';
import { Wrapper } from './TableTop.style';

export type TableTopProps = {};

export function TableTop(_props: TableTopProps) {
  const { state, patchState } = useContext(TableContext);

  function onSearch(q: string) {
    patchState({ q });
  }

  function onClear() {
    patchState({ q: '' });
  }

  return (
    <Wrapper className='TableTop-wrapper' data-testid='TableTop-wrapper'>
      <Search q={state.q} onSearch={onSearch} onClear={onClear} />
    </Wrapper>
  );
}

export default TableTop;
